export const odluka_o_isplati_dobiti2 = {
    templateId: 207.1,
    category: 4,
    templateTitle: 'Odluka o isplati dijela zadržane dobiti',
    templateDescription: `<p> Ukoliko poduzetnik ima ostvarenu i/ili zadržanu dobit, istu može isplatiti pridržavajući se odredbi Zakona o računovodstvu i Zakona o trgovačkim društvima.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Dobit se raspoređuje prema odredbama Zakona o trgovačkim društvima, a potom prema odredbama Zakona o računovodstvu te se tek onda može isplatiti vlasnicima.    </p>
    <p>Krajem svake poslovne godine utvrđuje se račun dobiti i gubitka. Na temelju toga računa, svakome se članu izračunava njegov udio u dobiti ili u gubitku, razmjerno njegovom udjelu u društvu.     </p>
    <p>Trgovačko društvo koje na datum bilance ima dobit raspoloživu za podjelu članovima društva sukladno odredbama Zakona o trgovačkim društvima, dužno je takvu dobit najprije uporabiti za unos u ostale rezerve iz dobiti, radi pokrića:</p>
    
    <li>neotpisanih troškova razvoja iskazanih u aktivi i </li>
    <li>dobiti koja se može pripisati sudjelujućim interesima i koja je iskazana u računu dobiti i gubitka, u iznosu koji nije primljen niti se njegova isplata može zahtijevati ako standardi financijskog izvještavanja dopuštaju ili zahtijevaju navedeni način iskazivanja troškova razvoja odnosno dobiti od sudjelujućih interesa.    </li>
    <br>

    <p>Ako ne postoji prethodno opisana obveza uporabe dobiti, dobit se može isplatiti u cijelom iznosu koji je raspoloživ (prema primjeru dokumenta u nastavku) ili u dijelu iznosa.    </p>
  
    <p>Dospijeće isplate dobiti bi se moralo odrediti u nekom razumnom vremenu, npr. 30 dana nakon donošenja odluke, a prema stavu Visokog trgovačkog suda RH izraženim u odluci
    Pž-2400/04 od 08. veljače 2005. godine.</p>

    <p>Primjer dokumenta za isplatu cijelog iznosa dobiti možete vidjeti <a class="local-link" href="/contract?template=207">ovdje</a>, zajedno s pripadajućim opisom dokumenta.</p>
   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p> Zakon o trgovačkim društvima, Zakon o računovodstvu, Društveni ugovor (Izjava o osnivanju).</p>
    ` ,
  
    sides: [
        {
            prefix: 'Na temelju odredbi Zakona o trgovačkim društvima i Zakona o računovodstvu,',
            signature: 'Predsjednik skupštine',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: " (u daljnjem tekstu: Društvo),",
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O ISPLATI DIJELA ZADRŽANE DOBITI',
    noArticleNumbers: true,

    articles: [
     
      {
        title: '',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                editable: true,
                mandatory: true,
                content: 'Utvrđuje se da ukupnu zadržanu dobit Društva čini dobit iz prethodnih godina u iznosu od _____________ kn i i dobit iz 20__. godine u iznosu od _________ kn, što daje ukupan iznos od ________ kn. ',
                value: '',
            }],
    },
    
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Dio zadržane dobiti Društva iz prethodnih godina u ukupnom iznosu od _____ kn isplatiti će se članovima Društva, sukladno odredbama ove Odluke, a u skladu s odredbama Društvenog ugovora.',
              value: '',
          }],
  },
{
  title: '',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          editable: true,
          mandatory: true,
          content: 'Pravo na isplatu dobiti ima svaki član Društva koji je na dan isplate dobiti utvrđene ovom Odlukom upisan u Knjigu poslovnih udjela Društva i o čijem upisu je obaviješten registarski sud, a prema pravu na dobit koje proizlazi iz poslovnih udjela.',
          value: '',
      }],
},
{
  title: '',
  mandatory: true,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          editable: true,
          mandatory: true,
          content: 'Dobit prema ovoj Odluci dospijeva za isplatu ___.___. 20__. godine.',
          help: 'Dospijeće isplate dobiti bi se moralo odrediti u nekom razumnom vremenu, npr. 30 dana nakon donošenja odluke, a prema stavu Visokog trgovačkog suda RH izraženim u odluci Pž-2400/04 od 08. veljače 2005. godine.',
          value: '',
      }],
},

    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Odluka se primjenjuje s danom donošenja.',
                value: '',
            }],
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
          {
              type: 'input',
              mandatory: true,
              parts: [
                  {
                      type: 'text',
                      content: 'U'
                  },
                  {
                      type: 'input',
                      value: '',
                      placeholder: "Upišite mjesto.",
                      required: true
                  },
                  {
                      type: 'text',
                      content: ', dana'
                  },
                  {
                      type: 'date',
                      value: new Date(),
                      required: true
                  },
                  {
                      type: 'text',
                      content: 'godine.',
                  }
              ]
          },
      ]
  },
  {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
  },
  {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
          {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Dostaviti:\r\n1) Odjel knjigovodstva \r\n2) Arhiva',
              help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
          }
      ]
  },
],
};







// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/207.1_odluka_o_isplati_dobiti2.ts